import { UntypedFormControl } from "@angular/forms";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class IbanValidator {
  constructor() {}

  validateIban(component: UntypedFormControl) {
    if (!window["IBAN"].isValid(component.value)) {
      // console.log("InValid " + component.value);
      return { validateIban: { valid: false } };
    } else {
      // console.log("Valid " + component.value);
      return null;
    }
  }
}
